/** Bot servers, queue, errors, view, and grid. */
export default [

  {
    path: '/bot-servers',
    name: 'Bot Servers',
    component: () => import('@/views/private/BotServersView.vue'),
    meta: {
      public: false,
      title: 'Bot Servers',
    },
  },

  {
    path: '/server-metrics',
    name: 'Server Metrics',
    component: () => import('@/views/private/ServerMetricsView.vue'),
    meta: {
      public: false,
      title: 'Server Metrics',
    },
  },

  {
    path: '/logs',
    name: 'Logs',
    component: () => import('@/views/private/LogsView.vue'),
    meta: {
      public: false,
      title: 'Logs',
    },
  },

  {
    path: '/database',
    name: 'Database',
    component: () => import('@/views/private/DatabaseView.vue'),
    meta: {
      public: false,
      title: 'Database',
    },
  },

  {
    path: '/queues',
    name: 'Queues',
    component: () => import('@/views/private/QueuesView.vue'),
    meta: {
      public: false,
      title: 'Queues',
    },
  },

  {
    path: '/performance',
    name: 'Performance',
    component: () => import('@/views/private/PerformanceView.vue'),
    meta: {
      public: false,
      title: 'Performance',
    },
  },

  {
    path: '/bots/:botServerId',
    name: 'Bots (by Server ID)',
    component: () => import('@/views/private/BotsView.vue'),
    props: function(route) {
      return {
        botServerId: Number(route.params.botServerId),
      };
    },
    meta: {
      public: false,
      title: 'Bots',
    },
  },

  {
    path: '/bots',
    name: 'Bots',
    component: () => import('@/views/private/BotsView.vue'),
    meta: {
      public: false,
      title: 'Bots',
    },
  },

  {
    path: '/bot-queue/:botId',
    name: 'Bot Queue (by Bot ID)',
    component: () => import('@/views/private/BotQueueView.vue'),
    props: function(route) {
      return {
        botId: Number(route.params.botId),
      };
    },
    meta: {
      public: false,
      title: 'Bot Queue',
    },
  },

  {
    path: '/bot-queue',
    name: 'Bot Queue',
    component: () => import('@/views/private/BotQueueView.vue'),
    meta: {
      public: false,
      title: 'Bot Queue',
    },
  },

  {
    path: '/bot-errors/:botId',
    name: 'Bot Errors (by Bot ID)',
    component: () => import('@/views/private/BotErrorsView.vue'),
    props: function(route) {
      return {
        botId: Number(route.params.botId),
      };
    },
    meta: {
      public: false,
      title: 'Bot Errors',
    },
  },

  {
    path: '/bot-errors',
    name: 'Bot Errors',
    component: () => import('@/views/private/BotErrorsView.vue'),
    meta: {
      public: false,
      title: 'bot-errors',
    },
  },

  {
    path: '/bot-view/:botId',
    name: 'Bot View (by Bot ID)',
    component: () => import('@/views/private/BotView.vue'),
    props: function(route) {
      return {
        botId: Number(route.params.botId),
      };
    },
    meta: {
      public: false,
      title: 'Bot View',
    },
  },

  {
    path: '/bot-view',
    name: 'Bot View',
    component: () => import('@/views/private/BotView.vue'),
    meta: {
      public: false,
      title: 'Bot View',
    },
  },

  {
    path: '/bot-grid/:botServerId',
    name: 'Bot Grid (by Server ID)',
    component: () => import('@/views/private/BotGridView.vue'),
    props: function(route) {
      return {
        botServerId: Number(route.params.botServerId),
      };
    },
    meta: {
      public: false,
      title: 'Bot Grid',
    },
  },

  {
    path: '/bot-grid',
    name: 'Bot Grid',
    component: () => import('@/views/private/BotGridView.vue'),
    meta: {
      public: false,
      title: 'Bot Grid',
    },
  },

];
